<item-preview-wrapper 
    class="virtual-service-preview"
    [config]="config"
    [isItem]="isItem"
>
    <item-preview-wrapper_custom-content
        class="virtual-service-preview__custom-content-section"
        *ngIf="isWafPolicyNotAttached && isTypeHttp && isVsBeingEdited"
    >
        <img
            id="waf-security-preview-image"
            src="src/img/vs-modal/vs-modal-try-waf-preview.svg"
            alt="l10nKeys.wafSecurityPreviewImageAlt | vtranslate"
            class="virtual-service-preview__image"
        />
        <div class="virtual-service-preview__preview-field-container">
            <preview-field class="virtual-service-preview__preview-field">
                <preview-field_label class="virtual-service-preview__preview-field-content">
                    {{ l10nKeys.wafEvaluationHeaderLabel | vtranslate }}
                </preview-field_label>
                <preview-field_val class="virtual-service-preview__preview-field-content">
                    {{ l10nKeys.wafEvaluationContentLabel | vtranslate }}
                </preview-field_val>
                <preview-field_val class="virtual-service-preview__preview-field-content">
                    <cds-button
                        id="dismiss-button"
                        action="flat"
                        (click)="dismissWafRecommendation()"
                    >
                        {{ l10nKeys.dismissButtonLabel | vtranslate }}
                    </cds-button>
                    <cds-button
                        id="try-waf-button"
                        action="outline"
                        (click)="showWafEvaluationRecommendationModal()"
                    >
                        {{ l10nKeys.tryWafButtonLabel | vtranslate }}
                    </cds-button>
                </preview-field_val>
            </preview-field>
        </div>
    </item-preview-wrapper_custom-content>

    <item-preview-wrapper_custom-content
        class="virtual-service-preview__custom-content-section"
        *ngIf="isEvalModeWafAttached && isTypeHttp && isVsBeingEdited"
    >
        <avi-full-modal-preview-message
            id="waf-policy-preview-message"
            [header]="l10nKeys.wafPolicyLabel | vtranslate"
            [statusText]="l10nKeys.evaluationModeStatusText | vtranslate"
            [statusIcon]="'shield'"
            [tooltipText]="l10nKeys.wafEvaluationContentLabel | vtranslate"
        ></avi-full-modal-preview-message>
    </item-preview-wrapper_custom-content>
</item-preview-wrapper>
